import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function Progress1(props) {
	return <div style={{ textAlign: 'center', width: '100%' }}><CircularProgress></CircularProgress><br />{props.text}</div>;
}